import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiBreadcrumbsModule } from '@taiga-ui/kit';
import { TuiLinkModule } from '@taiga-ui/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'rdw-refund-policy',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    TuiBreadcrumbsModule,
    TuiLinkModule,
    RouterLink,
  ],
  templateUrl: './refund-policy.component.html',
  styleUrls: ['./refund-policy.component.scss'],
})
export class RefundPolicyComponent {
  breadcrumbItems = [
    {
      caption: `breadcrumb.home`,
      routerLink: `/`,
    },
    {
      caption: `breadcrumb.refund-policy`,
      routerLink: `/refund-policy`,
      routerLinkActiveOptions: { exact: true },
    },
  ];

  readonly prefixTranslation = 'refund-policy.';
}
